/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function CMDDiscrepanciesGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();
  const discrepancies: any[] = [];
  const shortagesDenoms: any[] = [];
  const excessDenoms: any[] = [];

  const shortGrandTotals: any[] = [];
  const excGrandTotals: any[] = [];

  let netShortages = 0;
  let netExcesses = 0;

  requests.forEach((req: any) => {
    req.shortage.forEach((srt: any) => {
      const denom = shortagesDenoms.find(
        (dnm) => dnm.denomination === srt.denomination
      );

      if (!denom) {
        shortagesDenoms.push({ denomination: srt.denomination });
      }
    });

    const shortages: any = {};

    if (req.shortage) {
      req.shortage.forEach((srt: any) => {
        shortages[srt.denomination] = srt.notes;
      });
    } else {
      req.shortage.forEach((srt: any) => {
        shortages[srt.denomination] = 0;
      });
    }

    req.excess.forEach((ex: any) => {
      const denom = excessDenoms.find(
        (dnm) => dnm.denomination === ex.denomination
      );

      if (!denom) {
        excessDenoms.push({ denomination: ex.denomination });
      }
    });

    const excesses: any = {};

    if (req.excess) {
      req.excess.forEach((ex: any) => {
        excesses[ex.denomination] = ex.notes;
      });
    } else {
      req.excess.forEach((ex: any) => {
        excesses[ex.denomination] = 0;
      });
    }

    const discInfo = {
      serialNo: req.serialNo,
      locationId: req.locationId,
      locationName: req.locationName,
      serviceDate: req.serviceDate,
      processingDate: req.processingDate,
      shortagesDenoms,
      shortages,
      totalShortage: req.totalShortage,
      excessDenoms,
      excesses,
      totalExcess: req.totalExcess,
    };

    netShortages += req.totalShortage;
    netExcesses += req.totalExcess;

    discrepancies.push(discInfo);
    shortGrandTotals.push(shortages);
    excGrandTotals.push(excesses);
  });

  function sortByCurrency(a: any, b: any) {
    const first = a.denomination.split(" ")[1];
    const second = b.denomination.split(" ")[1];

    if (first < second) {
      return -1;
    }
    if (first > second) {
      return 1;
    }
    return 0;
  }

  function sortByMultiple(a: any, b: any) {
    const first = parseInt(a.denomination.split(" ")[1]);
    const second = parseInt(b.denomination.split(" ")[1]);

    if (first < second) {
      return -1;
    }
    if (first > second) {
      return 1;
    }
    return 0;
  }

  let sortedShortageDenoms = shortagesDenoms.sort(sortByCurrency);

  sortedShortageDenoms = sortedShortageDenoms.sort(sortByMultiple);

  let sortedExcessDenoms = excessDenoms.sort(sortByCurrency);

  sortedExcessDenoms = sortedExcessDenoms.sort(sortByMultiple);

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Id
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Name
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Service Date
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Processing Date
            </th>
            <th
              colSpan={sortedShortageDenoms.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Shortages
            </th>
            <th
              rowSpan={2}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total Shortage
            </th>
            <th
              colSpan={sortedExcessDenoms.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Excess
            </th>
            <th
              rowSpan={2}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Total Excess
            </th>
          </tr>
          <tr>
            {sortedShortageDenoms.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {sortedExcessDenoms.map((dnm, i) => {
              return (
                <th
                  key={`disp${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {discrepancies.map((res, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {res.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationId}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationName}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.serviceDate}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.processingDate}
                </td>
                {sortedShortageDenoms.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.shortages[denom]
                        ? nf.format(res.shortages[denom])
                        : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.totalShortage ? nf.format(res.totalShortage) : 0}
                </td>

                {sortedExcessDenoms.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`cn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.excesses[denom] ? nf.format(res.excesses[denom]) : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.totalExcess ? nf.format(res.totalExcess) : 0}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={5}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {sortedShortageDenoms.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              shortGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(netShortages)}
            </td>

            {sortedExcessDenoms.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              excGrandTotals.forEach((ct) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(netExcesses)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(CMDDiscrepanciesGrid);
